(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hd-get-started-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.hdGskInitialized === 'true') return;
      root.dataset.hdGskInitialized = 'true';

      const variants = JSON.parse(root.querySelector('[data-hd-gsk-variants]').textContent);
      const form = root.querySelector('.hd-gsk__form');
      const variantInput = root.querySelector('[data-hd-gsk-variant-id]');
      const addButton = root.querySelector('[data-hd-gsk-add]');
      const addLabel = root.querySelector('[data-hd-gsk-add-label]');
      const quantityInput = root.querySelector('[data-hd-gsk-quantity]');
      const price = root.querySelector('[data-hd-gsk-price]');
      const compare = root.querySelector('[data-hd-gsk-compare]');
      const save = root.querySelector('[data-hd-gsk-save]');
      const buttonPrice = root.querySelector('[data-hd-gsk-button-price]');
      const finalPrice = root.querySelector('[data-hd-gsk-final-price]');
      const stickyPrice = root.querySelector('[data-hd-gsk-sticky-price]');
      const selection = root.querySelector('[data-hd-gsk-selection]');
      const mainImage = root.querySelector('[data-hd-gsk-main-image]');
      const imageCount = root.querySelector('[data-hd-gsk-image-count]');
      const optionGroups = Array.from(root.querySelectorAll('[data-option-position]'));

      const selectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
      const currentVariant = () => {
        const options = selectedOptions();
        return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
      };

      const updateSelection = () => {
        const variant = currentVariant();
        const options = selectedOptions();
        const quantity = Math.max(1, Math.min(9, Number.parseInt(quantityInput.value || '1', 10)));
        quantityInput.value = String(quantity);
        selection.textContent = `${options.join(' · ')} · Qty ${quantity}`;
        if (!variant) {
          addButton.disabled = true;
          addLabel.textContent = root.dataset.soldOutLabel;
          return;
        }

        variantInput.value = String(variant.id);
        price.textContent = variant.priceFormatted;
        buttonPrice.textContent = variant.priceFormatted;
        finalPrice.textContent = variant.priceFormatted;
        stickyPrice.textContent = variant.priceFormatted;
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;

        if (variant.compareAt > variant.price) {
          compare.textContent = variant.compareAtFormatted;
          save.textContent = `Save ${variant.savingsFormatted}`;
          compare.classList.remove('hd-gsk__hidden');
          save.classList.remove('hd-gsk__hidden');
        } else {
          compare.classList.add('hd-gsk__hidden');
          save.classList.add('hd-gsk__hidden');
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      optionGroups.forEach((group) => group.addEventListener('change', updateSelection));
      root.querySelector('[data-hd-gsk-minus]').addEventListener('click', () => {
        quantityInput.value = String(Math.max(1, Number.parseInt(quantityInput.value || '1', 10) - 1));
        updateSelection();
      });
      root.querySelector('[data-hd-gsk-plus]').addEventListener('click', () => {
        quantityInput.value = String(Math.min(9, Number.parseInt(quantityInput.value || '1', 10) + 1));
        updateSelection();
      });
      quantityInput.addEventListener('change', updateSelection);

      root.querySelectorAll('[data-image-url]').forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          root.querySelectorAll('[data-image-url]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          thumbnail.setAttribute('aria-pressed', 'true');
          mainImage.style.opacity = '0';
          window.setTimeout(() => {
            mainImage.src = thumbnail.dataset.imageUrl;
            mainImage.alt = thumbnail.dataset.imageAlt;
            imageCount.textContent = `${thumbnail.dataset.imageIndex} of ${root.querySelectorAll('[data-image-url]').length}`;
            mainImage.style.opacity = '1';
          }, 150);
        });
      });

      root.querySelectorAll('[data-hd-gsk-proxy-add]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!addButton.disabled) {
            form.requestSubmit(addButton);
            return;
          }
          addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => addButton.focus(), 420);
        });
      });

      const hero = root.querySelector('[data-hd-gsk-purchase]');
      const sticky = root.querySelector('[data-hd-gsk-sticky]');
      const stickyObserver = new IntersectionObserver((entries) => {
        const visible = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.toggleAttribute('inert', !visible);
      }, { threshold: .15 });
      stickyObserver.observe(hero);

      const context = (new URLSearchParams(window.location.search).get('context') || '').trim().toLowerCase();
      const articleContexts = ['health-article', 'digestion', 'energy', 'circulation', 'stress'];
      if (articleContexts.includes(context)) root.querySelector('[data-hd-gsk-article-bridge]').hidden = false;

      form.addEventListener('submit', () => addButton.setAttribute('aria-busy', 'true'));
      updateSelection();
    };

    document.querySelectorAll('[data-hd-gsk]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-hd-gsk]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();
})();
